import React, { useEffect, useState } from "react";
import {
  I2cInput,
  I2cPhoneField,
  I2cIcon,
  I2cButton,
  I2cTabGroup,
  I2cTab,
  I2cTabPanel,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { emailAdressValidator } from "../../../Utils/stringUtls";

const AdminWebsite = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    users: Yup.array()
      .of(
        Yup.object({
          iac_aw_name: Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
          iac_aw_title: Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
          iac_aw_phone: Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
          iac_aw_fax: Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
          iac_aw_cell: Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
          iac_aw_email: Yup.string()
            .required(generalErrorMessage)
            .test(
              "Field is required",
              "Invalid email address",
              function (item) {
                // this.parent gives the whole parent
                return emailAdressValidator(item);
              },
            ),
        }),
      )
      .min(1, generalErrorMessage),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      users: [
        {
          iac_aw_name: "",
          iac_aw_title: "",
          iac_aw_phone: "",
          iac_aw_phone_country: "US",
          iac_aw_fax: "",
          iac_aw_fax_country: "US",
          iac_aw_cell: "",
          iac_aw_cell_country: "US",
          iac_aw_email: "",
        },
      ],
    },
  });

  const formFields = ["users"];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      formFields.forEach((field) => {
        methods.setValue(field, formDataJson[7]["7_0"][field] ?? "");
      });
      methods.trigger();
      handleValueChanges();
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "users", // Name of the array field in your form,
  });
  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, [fields]);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      7: {
        ...addFormData["7"],
        "7_0": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("7_0", true);
    else setFormValidStates("7_0", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">User Details</div>
            <div className="custom-label-light">
              Please provide the email address, Name and Contact information of
              individuals who will require administrator access.
            </div>
          </div>
          <div i2c-grid="12">
            <I2cTabGroup placement="top" activation="auto">
              {fields.map((user, index) => (
                <React.Fragment key={index}>
                  <I2cTab
                    active={index === activeTab}
                    onClick={(e) => setActiveTab(index)}
                    key={index}
                    slot="nav"
                    panel={index + 1}
                  >
                    User {index + 1}
                  </I2cTab>
             
                  <I2cTabPanel active={index === activeTab} name={index + 1}>
                    <div key={index} i2c-grid="grid gap-column-sm gap-row-md">
                      <div i2c-grid="6@md">
                        <Controller
                          name={"iac_aw_name" + index}
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              label="Name"
                              {...field}
                              name={"iac_aw_name" + index}
                              placeholder="Name"
                              size="large"
                              value={methods.watch(`users`)[index]?.iac_aw_name}
                              key={user.id} // important to include key with field's id
                              onI2cInput={(e) => {
                                methods.setValue(
                                  `users.${index}.iac_aw_name`,
                                  e.target.value,
                                );
                                methods.trigger();
                                handleValueChanges();
                              }}
                              required
                            />
                          )}
                        />
                        {/* {errors?.users?.length &&
                        methods.formState.touchedFields ? (
                          <ErrorMessage
                            show={
                              errors.users[index]?.iac_aw_name &&
                              methods.formState.touchedFields?.[
                                "iac_aw_name" + index
                              ]
                                ? true
                                : false
                            }
                            message={
                              errors?.users[index]?.iac_aw_name?.message ??
                              "Invalid input"
                            }
                          />
                        ) : null} */}
                      </div>
                      <div i2c-grid="6@md">
                        <Controller
                          name={"iac_aw_title" + index}
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              label="Title"
                              {...field}
                              placeholder="Title"
                              name="iac_aw_title"
                              size="large"
                              value={
                                methods.watch(`users`)[index]?.iac_aw_title
                              }
                              required
                              key={user.id} // important to include key with field's id
                              onI2cInput={(e) => {
                                methods.setValue(
                                  `users.${index}.iac_aw_title`,
                                  e.target.value,
                                );
                                methods.trigger();
                                handleValueChanges();
                              }}
                            />
                          )}
                        />
                        {/* {errors?.users?.length &&
                        methods.formState.touchedFields ? (
                          <ErrorMessage
                            show={
                              errors.users[index]?.iac_aw_title &&
                              methods.formState.touchedFields?.[
                                "iac_aw_title" + index
                              ]
                                ? true
                                : false
                            }
                            message={
                              errors?.users[index]?.iac_aw_title?.message ??
                              "Invalid input"
                            }
                          />
                        ) : null} */}
                      </div>
                      <div i2c-grid="6@md">
                        <I2cPhoneField
                          format="INTERNATIONAL"
                          name="iac_aw_phone"
                          label="Phone Number"
                          size="large"
                          country-box
                          key={user.id}
                          onI2cChange={(e) => {

                            const country = e.target.country;
                            const isValid = e.target.isValid;
                            const value = e.target.value;
                            methods.setValue(
                              `users.${index}.iac_aw_phone_country`,
                              country,
                            );
                            methods.setValue(
                              `users.${index}.iac_aw_phone`,
                              value,
                            );
                            methods.trigger();
                            handleValueChanges();
                            if (!isValid) {
                              methods.setError(`users.${index}.iac_aw_phone`, {
                                type: "manual",
                                message: e.target.guide,
                              });
                            } else {
                              methods.clearErrors(
                                `users.${index}.iac_aw_phone`,
                              );
                            }
                          }}
                          required
                          selectedCountry={
                            methods.watch(
                              `users.${index}.iac_aw_phone_country`,
                            ) || "US"
                          }
                          placeholder="1 (212) 313-2123"
                          value={methods.watch(`users.${index}.iac_aw_phone`) || ""}
                        />
                      </div>
                      <div i2c-grid="6@md">
                        <I2cPhoneField
                          format="INTERNATIONAL"
                          name="iac_aw_cell"
                          label="Cell Number"
                          size="large"
                          country-box
                          key={user.id}
                          onI2cChange={(e) => {
                            const country = e.target.country;
                            const isValid = e.target.isValid;
                            const value = e.target.value;
                            methods.setValue(
                              `users.${index}.iac_aw_cell_country`,
                              country,
                            );
                            methods.setValue(
                              `users.${index}.iac_aw_cell`,
                              value,
                            );
                            methods.trigger();
                            handleValueChanges();
                            if (!isValid) {
                              methods.setError(`users.${index}.iac_aw_cell`, {
                                type: "manual",
                                message: e.target.guide,
                              });
                            } else {
                              methods.clearErrors(`users.${index}.iac_aw_cell`);
                            }
                          }}
                          required
                          selectedCountry={
                            methods.watch(
                              `users.${index}.iac_aw_cell_country`,
                            ) || "US"
                          }
                          placeholder="1 (212) 313-2123"
                          value={methods.watch(`users.${index}.iac_aw_cell`) || ""}
                        />
                      </div>
                      <div i2c-grid="6@md">
                        <I2cPhoneField
                          format="INTERNATIONAL"
                          label="Fax"
                          name={`iac_aw_fax`}
                          size="large"
                          country-box
                          key={user.id}
                          onI2cChange={(e) => {
                            const country = e.target.country;
                            const isValid = e.target.isValid;
                            const value = e.target.value;
                            methods.setValue(
                              `users.${index}.iac_aw_fax_country`,
                              country,
                            );
                            methods.setValue(
                              `users.${index}.iac_aw_fax`,
                              value,
                            );
                            methods.trigger();
                            handleValueChanges();
                            if (!isValid) {
                              methods.setError(`users.${index}.iac_aw_fax`, {
                                type: "manual",
                                message: e.target.guide,
                              });
                            } else {
                              methods.clearErrors(`users.${index}.iac_aw_fax`);
                            }
                          }}
                          required
                          selectedCountry={
                            methods.watch(
                              `users.${index}.iac_aw_fax_country`,
                            ) || "US"
                          }
                          placeholder="1 (212) 313-2123"
                          value={methods.watch(`users.${index}.iac_aw_fax`) || ""}
                        />
                      </div>
                      <div i2c-grid="6@md">
                        <Controller
                          name={"iac_aw_email" + index}
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              label="Email"
                              placeholder="Email"
                              name="iac_aw_email"
                              size="large"
                              required
                              type="email"
                              value={methods.watch(`users`)[index].iac_aw_email}
                              key={user.id} // important to include key with field's id
                              onI2cInput={(e) => {
                                methods.setValue(
                                  `users.${index}.iac_aw_email`,
                                  e.target.value,
                                );
                                methods.trigger();
                                handleValueChanges();
                              }}
                            />
                          )}
                        />
                        {/* {errors?.users?.length &&
                        methods.formState.touchedFields ? (
                          <ErrorMessage
                            show={
                              errors.users[index]?.iac_aw_email &&
                              methods.formState.touchedFields?.[
                                "iac_aw_email" + index
                              ]
                                ? true
                                : false
                            }
                            message={
                              errors?.users[index]?.iac_aw_email?.message ??
                              "Invalid input"
                            }
                          />
                        ) : null} */}
                      </div>
                      <div i2c-grid="12">
                        {index > 0 && (
                          <I2cButton
                            onClick={() => {
                              const filteredData = fields.filter(
                                (user, ind) => ind !== index,
                              );
                              remove(index);
                              methods.setValue("users", filteredData);
                              setActiveTab(index - 1);
                              methods.trigger();
                              handleValueChanges();
                            }}
                            destructive
                          >
                            Delete
                          </I2cButton>
                        )}
                      </div>
                    </div>
                  </I2cTabPanel>
                </React.Fragment>
              ))}
            </I2cTabGroup>
          </div>
          <div i2c-grid="12">
            <I2cButton
              variant="secondary gray"
              disabled={fields.length === 5}
              onClick={() => {
                append({
                  iac_aw_name: "",
                  iac_aw_title: "",
                  iac_aw_phone: "",
                  iac_aw_phone_country: "",
                  iac_aw_fax: "",
                  iac_aw_fax_country: "",
                  iac_aw_cell: "",
                  iac_aw_cell_country: "",
                  iac_aw_email: "",
                });
                setActiveTab(fields.length);
              }}
            >
              <I2cIcon
                name="linear-add"
                label="placeholder"
                slot="prefix"
              ></I2cIcon>
              Add User
            </I2cButton>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminWebsite;
